<app-site-widget
    *ngIf="data"
	[title]="title"
	[elementId]="elementId"
	chartType="column"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{hasExport: true}"
	(eventEmit)="eventEmit($event)"
	[data]="data"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>